import React from "react";
import "./ManufacturingPlant.css";

import heroImg from "../assets/images/header-partnering-plantas-1-scaled.jpg";
import spainMap from "../assets/images/mapa-plantas-partnering.png";
import img1 from "../assets/images/p-olloki-1.jpg";
import img2 from "../assets/images/p-huarte.jpg";
import img3 from "../assets/images/madrid.jpg";
import img4 from "../assets/images/cyndea.jpg";

export default function ManufacturingPlant() {
  return (
    <div className="manufacturing-page">

      {/* ================= HERO ================= */}
      <section
        className="manufacturing-hero"
        style={{ backgroundImage: `url(${heroImg})` }}
      >
    
        <div className="hero-content">
          <h1>
            <span className="green">3 medicine manufacturing</span>
            <br />
            <span className="purple">plants and 2 R&amp;D+i centres</span>
          </h1>
        </div>
      </section>

      {/* ================= INTRO TEXT ================= */}
      <section className="manufacturing-text-section">
        <div className="container">
          <div className="two-col">
            <div>
              <p>
                At our manufacturing plants, we produce both high demand
                medicines for globally prevalent diseases as well as highly
                specialised treatments.
              </p>
              <p>
                They come in various pharmaceutical forms, such as soft gelatin
                capsules, tablets, liquids and sachets, among others.
              </p>
            </div>

            <div>
              <p>
                Cyndea Pharma is our manufacturing plant specialising in the
                development and production of steroid based medicines in soft
                gelatin capsules and cancer treatments, with a focus on women’s
                health and hormone-dependent cancer therapies.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ================= MAP SECTION ================= */}
      <section className="locations-section">
        <div className="container locations-grid">

          <div className="locations-list">
            <LocationItem number="1" text="Cinfa Olloki | Plant | Olloki (Navarre)" />
            <LocationItem number="2" text="Cinfa Huarte | Plant and R&D+i Centre | Huarte (Navarre)" />
            <LocationItem number="3" text="Cinfa Madrid | R&D+i Centre | Alcalá de Henares (Madrid)" />
            <LocationItem number="4" text="Cyndea Pharma | Plant | Ólvega (Soria)" />
          </div>

          <div className="locations-map">
            <img src={spainMap} alt="Spain Map" />
          </div>

        </div>
      </section>

      {/* ================= PLANTS GRID ================= */}
      <section className="plants-section">
        <div className="plants-container">

          <PlantCard
            image={img1}
            title="Cinfa Olloki"
            subtitle="Plant"
            description="Headquarters and main facilities"
          />

          <PlantCard
            image={img2}
            title="Cinfa Huarte"
            subtitle="Plant and R&D+i Centre"
            description="R&D+i, quality control, manufacturing and packaging of solids, liquids and flavours"
            reverse
          />

          <PlantCard
            image={img3}
            title="Cinfa Madrid"
            subtitle="R&D+i Centre"
            description="Development of high value-added or complex medicines"
          />

          <PlantCard
            image={img4}
            title="Cyndea Pharma"
            subtitle="Plant"
            description="Development and manufacturing of steroid based medicines and cancer treatments"
            reverse
          />

        </div>
      </section>

    </div>
  );
}


/* ================= SUB COMPONENTS ================= */

function LocationItem({ number, text }) {
  return (
    <div className="location-item">
      <span className="number">{number}</span>
      <p>{text}</p>
    </div>
  );
}

function PlantCard({ image, title, subtitle, description, reverse }) {
  const words = title.split(" ");
  const first = words.shift();
  const rest = words.join(" ");

  return (
    <div className={`plant-card ${reverse ? "reverse" : ""}`}>
      <div className="plant-image">
        <img src={image} alt={title} />
      </div>

      <div className="plant-content">
        <h2 className="plant-title">
          <span className="green">{first}</span>{" "}
          <span className="purple">{rest}</span>
        </h2>

        <h4 className="plant-subtitle">{subtitle}</h4>
        <p className="plant-description">{description}</p>
      </div>
    </div>
  );
}